function megaMenu() {

  if (!window.JSAPP_CONFIG['MEGA_MENU_ENABLED']) {
    return
  }

  let isMobile
  const mobileWidthLimit = 1199
  const checkIsMobile = () => {
    isMobile = window.innerWidth <= mobileWidthLimit
  }

  checkIsMobile()
  window.addEventListener('resize', checkIsMobile)

  const megamenu = document.querySelector('.megamenu')
  const megamenuItems = megamenu.querySelectorAll('.megamenu__item:not(.megamenu__item--special)')
  const navItemsWithSubmenu = megamenu.querySelectorAll('.megamenu-hs')
  const megamenuFirstSubs = megamenu.querySelectorAll('.megamenu-sub--first')
  const megamenuBanners = JSON.parse(document.getElementById('mm-banners').textContent)
  const megamenuOpenMobileBtn = document.querySelectorAll('.js-open-menu')
  const megamenuMobileClose = megamenu.querySelector('.megamenu__close').querySelector('i')
  const megamenuSpecialItem = megamenu.querySelector('.megamenu__item--special')
  const megamenuSpecial = document.querySelector('.category-special-menu')
  const megamenuSpecialBackBtn = megamenuSpecial.querySelector('.category-special-menu__head')
  const megamenuProductBox = megamenu.querySelectorAll('.prod-box__main-link')
  const megamenuProductBoxAddToCart = megamenu.querySelectorAll('.prod-box__btn')

  const getBannersContainer = (item) => {
    let bannersContainer = item.querySelectorAll('.megamenu-banners')

    return bannersContainer[bannersContainer.length-1]
  }

  const setBanners = (item, reset) => {
    let catId = item.dataset.id
    let rootId = item.dataset.rootid
    if (rootId) {
      item = megamenu.querySelector(`.megamenu__item[data-id="${rootId}"]`)
    }

    let bannersContainer = getBannersContainer(item)
    let bannersData = megamenuBanners[catId]
    let largeBanners = bannersContainer.querySelectorAll('.megamenu-banners__large')
    let largeBannersData = ''
    let smallBanners = ''
    let smallBannersData = ''
    let content = ''
    let contents = ''

    contents = item.querySelectorAll('.megamenu-sub__top')
    content = contents[contents.length-1]
    content.style.display = 'block'
    bannersContainer.querySelector('.megamenu-banners__boxes').innerHTML = ''

    if (!bannersData) {
      if (reset) {
        for (let x = 0; x < largeBanners.length; x++) {
          largeBanners[x].style.display = 'none'
        }
      }
      return
    }

    largeBannersData = (bannersData.RECTANGLE) ? bannersData.RECTANGLE : bannersData
    if (!largeBannersData) {
      return
    }

    largeBannersData.banner = (!largeBannersData.banner) ? largeBannersData.topBanner : largeBannersData.banner
    largeBannersData.banner_mobile = (!largeBannersData.banner_mobile) ? largeBannersData.topBannerMobile : largeBannersData.banner_mobile

    if (typeof largeBannersData.banner !== "undefined" && typeof largeBannersData.banner_mobile !== "undefined") {
      for (let x = 0; x < largeBanners.length; x++) {
        let bannerUrl = (isMobile) ? largeBannersData.banner_mobile : largeBannersData.banner
        let gtmData = prepareDataForGTM(largeBannersData)
        largeBanners[x].style.backgroundImage = `url(${bannerUrl})`
        largeBanners[x].style.display = 'block'
        largeBanners[x].href = largeBannersData.banner_url
        largeBanners[x].dataset.catId = catId
        largeBanners[x].rel = 'nofollow'
        largeBanners[x].setAttribute('data-gtm', JSON.stringify(gtmData))

        if (!megamenuBanners[catId].largeViewPromotion) {
          dataLayer.push({
            event: 'view_promotion',
            ecommerce: gtmData
          })

          largeBanners[x].addEventListener('click', () => {
            dataLayer.push({
              event: 'select_promotion',
              ecommerce: gtmData
            })
          })

          megamenuBanners[catId].largeViewPromotion = true
        }
      }
    }

    smallBannersData = (bannersData.BOX) ? bannersData.BOX : {}
    smallBanners = bannersContainer.querySelectorAll('.megamenu-banners__small')

    if (!rootId || !smallBannersData.length) {
      return
    }

    content.style.display = 'none'
    for (let x = 0; x < smallBannersData.length; x++) {
      let smallBox = document.createElement('div')
      let smallBanner = document.createElement('a')
      let bannerUrl = (isMobile) ? smallBannersData[x].banner_mobile : smallBannersData[x].banner
      let gtmData = prepareDataForGTM(smallBannersData[x])

      smallBox.classList.add('megamenu-banners__box');
      smallBanner.style.backgroundImage = `url(${bannerUrl})`
      smallBanner.href = smallBannersData[x].banner_url
      smallBanner.dataset.catId = catId
      smallBanner.classList.add('megamenu-banners__small')
      smallBanner.dataset.text = smallBannersData[x].banner_title
      smallBanner.rel = 'nofollow'
      smallBanner.setAttribute('data-gtm', JSON.stringify(gtmData))

      smallBox.append(smallBanner)

      bannersContainer.querySelector('.megamenu-banners__boxes').appendChild(smallBox)

      if (!megamenuBanners[catId].smallViewPromotion) {
        dataLayer.push({
          event: 'view_promotion',
          ecommerce: gtmData
        })
      }

      smallBanner.addEventListener('click', () => {
        dataLayer.push({
          event: 'select_promotion',
          ecommerce: gtmData
        })
      })
    }

    if (isMobile) {
      const slider = new Glider(bannersContainer.querySelector('.megamenu-banners__boxes'), {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        dots: false,
        rewind: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      })
    }

    megamenuBanners[catId].smallViewPromotion = true
  }

  const copyContent = (item) => {
    let rootId = item.dataset.rootid
    if (!rootId || item.dataset.contentCopied || !isMobile) {
      return
    }

    let contents = megamenu.querySelector(`.megamenu__item[data-id="${rootId}"]`).querySelectorAll('.megamenu-sub__content')
    let content = contents[contents.length - 1].cloneNode(true)
    let itemSub = item.querySelector('.megamenu-sub')

    itemSub.append(content)
    item.dataset.contentCopied = true
  }

  const prepareDataForGTM = (data) => {
    let sizes = ['prostokąt', 'kwadrat']
    let menu_tab_id = data.banner_tab_id || ''
    let menu_cat_id = data.banner_cat_id || ''
    let banner_gtm = data.gtm || data.topBannerGtm

    let dataForGTM = {
      promotion_id: data.gtm || data.banner_id,
      promotion_name: data.banner_title,
      creative_name: data.banner_title,
      creative_slot: 'Megamenu_' + sizes[data.banner_size] + '_menu_tab_id-' + menu_tab_id + '_cat_id-' + menu_cat_id
    }

    return dataForGTM
  }

  let navItemsWithSubmenuActive = []

  const links = document.querySelectorAll('.megamenu-sub-list a')

  links.forEach(link => {
    link.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault()
        link.click()
      }
    })
  })

  for (let i = 0; i < megamenuItems.length; i++) {
    if (window.innerWidth >= 1200) {
      megamenuItems[i].addEventListener('mouseenter', () => {
        document.documentElement.classList.add('dropdown-is-open')
        const submenu = megamenuItems[i].querySelector('.megamenu-sub--first')
        submenu.style.display = 'block'
        setBanners(megamenuItems[i])
      })
    }

    megamenuItems[i].addEventListener('keydown', (e) => {
      const submenu = megamenuItems[i].querySelector('.megamenu-sub')

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        if (window.innerWidth >= 1200 && submenu && submenu.classList.contains('megamenu-sub--first')) {
          // Display megamenu for desktop on enter
          megamenuItems[i].classList.add('megamenu__item--act')
          submenu.style.display = 'block'

          // Change focus
          if (e.target.classList.contains('megamenu-first__item')) {
            megamenuItems[i].querySelector('.megamenu-sub__nav ul li a').focus()
          } else {
            const closeSubmenuButton = navItemsWithSubmenu[i].querySelector('.megamenu-sub .megamenu-sub__head i')

            if (closeSubmenuButton) {
              closeSubmenuButton.focus();
            }
          }

          // Set hidden megemenu on focusout
          submenu.addEventListener('focusout', (event) => {
            if (!megamenuItems[i].contains(event.relatedTarget)) {
              return

            } else if (!submenu.contains(event.relatedTarget)) {
              setTimeout( function() {
                submenu.style.display = 'none'
                megamenuItems[i].classList.remove('megamenu__item--act')
                document.documentElement.classList.remove('dropdown-is-open')
              }, 200)
            }
          })
        }

        document.documentElement.classList.add('dropdown-is-open')
      }
    })

    megamenuItems[i].addEventListener('click', (e) => {
      if (e.target === megamenuItems[i]) {
        const submenu = megamenuItems[i].querySelector('.megamenu-sub')
        submenu.style.display = 'block'
        megamenuItems[i].classList.add('megamenu__item--act')
      }
    })

    megamenuItems[i].addEventListener('keydown', (e) => {
      if ((e.key === 'Enter' || e.key === ' ') && window.innerWidth <= 1200 && e.target === megamenuItems[i]) {
        const submenu = megamenuItems[i].querySelector('.megamenu-sub')
        submenu.style.display = 'block'
        megamenuItems[i].classList.add('megamenu__item--act')
      }
    })

    megamenuItems[i].addEventListener('mouseleave', () => {
      document.documentElement.classList.remove('dropdown-is-open')
      const submenu = megamenuItems[i].querySelector('.megamenu-sub')
      submenu.style.display = 'none'

      if (navItemsWithSubmenuActive.length > 0) {
        for (let x = 0; x < navItemsWithSubmenuActive.length; x++) {
          navItemsWithSubmenuActive[x].classList.remove('megamenu-hs--active')
        }
      }
    })
  }

  for (let i = 0; i < navItemsWithSubmenu.length; i++) {
    navItemsWithSubmenu[i].querySelector('a').addEventListener('click', (e) => {
      e.preventDefault()
      if (navItemsWithSubmenu[i].classList.contains('megamenu-hs--active')) {
        return
      }
      navItemsWithSubmenu[i].classList.add('megamenu-hs--active')

      setBanners(navItemsWithSubmenu[i])
      copyContent(navItemsWithSubmenu[i])
      navItemsWithSubmenuActive.push(navItemsWithSubmenu[i])
    })

    navItemsWithSubmenu[i].querySelector('.megamenu-sub__head i').addEventListener('click', (e) => {
      navItemsWithSubmenu[i].classList.remove('megamenu-hs--active')
      const submenuMobile = navItemsWithSubmenu[i].querySelector('.megamenu__item.megamenu__item__submenu.megamenu__item--act')

      if (submenuMobile) {
        submenuMobile.classList.remove('megamenu__item--act')
      }
      let toid = e.target.dataset.toid
      let items = megamenu.querySelectorAll(`li[data-id="${toid}"]`)
      setBanners(items[items.length-1], true)
    })

    navItemsWithSubmenu[i].querySelector('.megamenu-sub__head i').addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        navItemsWithSubmenu[i].classList.remove('megamenu-hs--active')
        const submenuMobile = navItemsWithSubmenu[i].querySelector('.megamenu__item.megamenu__item__submenu.megamenu__item--act')

        if (submenuMobile) {
          submenuMobile.classList.remove('megamenu__item--act')
        }
        let toid = e.target.dataset.toid
        let items = megamenu.querySelectorAll(`li[data-id="${toid}"]`)
        setBanners(items[items.length-1], true)
      }
    })
  }

  for (let i = 0; i < megamenuFirstSubs.length; i++) {
    megamenuFirstSubs[i].querySelector('.megamenu-sub__head i').addEventListener('click', (e) => {
      megamenuFirstSubs[i].parentNode.classList.remove('megamenu__item--act')
      megamenuFirstSubs[i].style.display = 'none'
    })

    megamenuFirstSubs[i].querySelector('.megamenu-sub__head i').addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        megamenuFirstSubs[i].parentNode.classList.remove('megamenu__item--act')
        megamenuFirstSubs[i].style.display = 'none'
      }
    });
  }

  for (let i = 0; i < megamenuOpenMobileBtn.length; i++) {
    megamenuOpenMobileBtn[i].addEventListener('click', (e) => {
      e.preventDefault()
      document.body.classList.add('js-is-mm-open')
      megamenuMobileClose.focus()
    })
  }

  megamenuMobileClose.addEventListener('click', () => {
    document.body.classList.remove('js-is-mm-open')
  })

  megamenuMobileClose.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      document.body.classList.remove('js-is-mm-open')
    }
  });

  megamenuSpecialItem.addEventListener('click', (e) => {
    megamenuSpecial.style.display = 'block'
  })

  megamenuSpecialItem.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      megamenuSpecial.style.display = 'block'
    }
  });

  megamenuSpecialBackBtn.addEventListener('click', (e) => {
    megamenuSpecial.style.display = 'none'
    megamenuSpecialItem.focus()
  })

  megamenuSpecialBackBtn.addEventListener('keydown', (e) => {
    if (event.key === 'Enter' || event.key === ' ') {
      megamenuSpecial.style.display = 'none'
      megamenuSpecialItem.focus()
    }
  })

  megamenuProductBox.forEach(function (elem) {
    let list = 'Megamenu - ' + elem.closest('.megamenu__item').dataset.itemName + ' - Produkt tygodnia'
    let category = elem.closest('.megamenu__item').dataset.itemName
    elem.parentElement.querySelector('form').querySelector('input[name="listCategory"]').value = list
    elem.addEventListener('click', () => {
      dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: {
              list: list,
              action: 'click'
            },
            products: [
              {
                id: elem.dataset.sku,
                name: elem.dataset.name,
                category: category,
                brand: elem.dataset.brand,
                list: list,
                position: '1'
              }
            ]
          }
        }
      })
    })

    elem.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        dataLayer.push({
          event: 'productClick',
          ecommerce: {
            click: {
              actionField: {
                list: list,
                action: 'click'
              },
              products: [
                {
                  id: elem.dataset.sku,
                  name: elem.dataset.name,
                  category: category,
                  brand: elem.dataset.brand,
                  list: list,
                  position: '1'
                }
              ]
            }
          }
        })

        elem.click();
      }
    })

    if (Object.prototype.toString.call(staticImpressions) !== '[object Array]') {
      window.staticImpressions = [];
    }

    let staticImpressionsData = {};
    staticImpressionsData['Megamenu-' + elem.dataset.id] = {
      id: elem.dataset.sku,
      name: elem.dataset.name,
      brand: elem.dataset.brand,
      category: category,
      list: list,
      position: '1'
    }
    staticImpressions = extend(staticImpressions, staticImpressionsData);

  })

  megamenuProductBoxAddToCart.forEach(function (elem) {
    elem.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        elem.click();

        console.log('Hire')

        setTimeout( function () {
          const mapButton = document.querySelector('.pharmacy-map__switch-to-map');
          if (isInViewport(elem)) {
            mapButton.focus()
          }
        }, 1000)
      }
    })
  })

}

function isInViewport(el) {
  if (!el) return false;

  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export { megaMenu }
